exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reappraisal-board-selector[data-v-1d7dc310]{max-width:500px;margin:0 auto}.selector-card[data-v-1d7dc310]{min-height:322px}.card-content[data-v-1d7dc310]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;height:100%;min-height:318px}.bottom-section[data-v-1d7dc310],.top-section[data-v-1d7dc310]{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0}.bottom-section[data-v-1d7dc310]{margin-top:auto}.leader-select[data-v-1d7dc310]{margin-top:20px}.warning-container[data-v-1d7dc310]{min-height:20px;margin-top:20px}.warning[data-v-1d7dc310]{color:#c0392b;font-size:14px}.warning-placeholder[data-v-1d7dc310]{height:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1d7dc310","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/ReappraisalBoardSelector.vue
// module id = DtS0
// module chunks = 1